/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetRiskUserBreakdownSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type GetRiskUserBreakdownSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type GetRiskUserBreakdownSecurity = {
  option1?: GetRiskUserBreakdownSecurityOption1 | undefined;
  option2?: GetRiskUserBreakdownSecurityOption2 | undefined;
};

export type GetRiskUserBreakdownRequest = {
  /**
   * External user identifier to scope the breakdown to.
   */
  externalUserId: string;
  /**
   * Inclusive start of the window. Defaults to the same 7-day window as the overview.
   */
  from?: Date | undefined;
  /**
   * Exclusive end of the window. Defaults to now.
   */
  to?: Date | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type GetRiskUserBreakdownSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const GetRiskUserBreakdownSecurityOption1$outboundSchema: z.ZodMiniType<
  GetRiskUserBreakdownSecurityOption1$Outbound,
  GetRiskUserBreakdownSecurityOption1
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function getRiskUserBreakdownSecurityOption1ToJSON(
  getRiskUserBreakdownSecurityOption1: GetRiskUserBreakdownSecurityOption1,
): string {
  return JSON.stringify(
    GetRiskUserBreakdownSecurityOption1$outboundSchema.parse(
      getRiskUserBreakdownSecurityOption1,
    ),
  );
}

/** @internal */
export type GetRiskUserBreakdownSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const GetRiskUserBreakdownSecurityOption2$outboundSchema: z.ZodMiniType<
  GetRiskUserBreakdownSecurityOption2$Outbound,
  GetRiskUserBreakdownSecurityOption2
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getRiskUserBreakdownSecurityOption2ToJSON(
  getRiskUserBreakdownSecurityOption2: GetRiskUserBreakdownSecurityOption2,
): string {
  return JSON.stringify(
    GetRiskUserBreakdownSecurityOption2$outboundSchema.parse(
      getRiskUserBreakdownSecurityOption2,
    ),
  );
}

/** @internal */
export type GetRiskUserBreakdownSecurity$Outbound = {
  Option1?: GetRiskUserBreakdownSecurityOption1$Outbound | undefined;
  Option2?: GetRiskUserBreakdownSecurityOption2$Outbound | undefined;
};

/** @internal */
export const GetRiskUserBreakdownSecurity$outboundSchema: z.ZodMiniType<
  GetRiskUserBreakdownSecurity$Outbound,
  GetRiskUserBreakdownSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => GetRiskUserBreakdownSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => GetRiskUserBreakdownSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function getRiskUserBreakdownSecurityToJSON(
  getRiskUserBreakdownSecurity: GetRiskUserBreakdownSecurity,
): string {
  return JSON.stringify(
    GetRiskUserBreakdownSecurity$outboundSchema.parse(
      getRiskUserBreakdownSecurity,
    ),
  );
}

/** @internal */
export type GetRiskUserBreakdownRequest$Outbound = {
  external_user_id: string;
  from?: string | undefined;
  to?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const GetRiskUserBreakdownRequest$outboundSchema: z.ZodMiniType<
  GetRiskUserBreakdownRequest$Outbound,
  GetRiskUserBreakdownRequest
> = z.pipe(
  z.object({
    externalUserId: z.string(),
    from: z.optional(z.pipe(z.date(), z.transform(v => v.toISOString()))),
    to: z.optional(z.pipe(z.date(), z.transform(v => v.toISOString()))),
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      externalUserId: "external_user_id",
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function getRiskUserBreakdownRequestToJSON(
  getRiskUserBreakdownRequest: GetRiskUserBreakdownRequest,
): string {
  return JSON.stringify(
    GetRiskUserBreakdownRequest$outboundSchema.parse(
      getRiskUserBreakdownRequest,
    ),
  );
}
